export const imageFileTypes = ["image/svg+xml", "image/jpeg", "image/png", "image/webp"];
export const videoFileTypes = ["video/mp4", "video/webm"];
